import { Box } from "@mui/material";
import { FormikProps } from "formik";
import StyledFormModal from "../../../../../../../../../../../../../components/globalModal/StyledModal";
import StyledButtonV2 from "../../../../../../../../../../../../../components/app/StyledButtonV2";
import { DisclosureHost } from "../../../../../../../../../../../../../hooks/use-disclosure";
import useFormDraft from "../../../../../../../../../../../../../hooks/use-form-draft";
import { Form2Payload } from "../../../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import PsychiatricHistorySection from "./PsychiatricHistorySection";
import { PSYCHIATRIC_HISTORY_SECTIONS } from "./PsychiatricEvolutionFormConstant";

interface PsychiatricEvolutionFormProps {
  disclosureHost: DisclosureHost;
  formik: FormikProps<Form2Payload>;
}

// Fields this modal owns: every history section selection plus its note.
const PSYCHIATRIC_EVALUATION_FIELDS = PSYCHIATRIC_HISTORY_SECTIONS.flatMap(
  (section) => [section.key, `${section.key}Note`]
);

export const PsychiatricEvolutionForm = ({
  disclosureHost,
  formik,
}: PsychiatricEvolutionFormProps) => {
  // Edits stay in the draft until Save, so the note behind the modal is
  // untouched while the user is still filling it in (ECRH-5663).
  const draft = useFormDraft(
    formik,
    PSYCHIATRIC_EVALUATION_FIELDS,
    disclosureHost.opened
  );

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle="Psychiatric Evaluation"
      dialogAction={
        <>
          <StyledButtonV2
            label="Close"
            variant="outlined"
            onClick={() => {
              disclosureHost.close();
            }}
            sx={{ width: "100px" }}
          />
          <StyledButtonV2
            label="Save"
            variant="contained"
            onClick={() => {
              draft.save();
              disclosureHost.close();
            }}
            sx={{ width: "110px" }}
          />
        </>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: "70vw",
          height: "80vh",
        },
      }}
    >
      <Box width={"100%"} padding={1} mt={0.5}>
        {/* Past Psychodynamic / Medical / Substance Use History */}
        <PsychiatricHistorySection formik={draft} />
      </Box>
    </StyledFormModal>
  );
};
